import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import Layout from './components/Layout'
import SimulationPage from './pages/SimulationPage'
import AboutPage from './pages/AboutPage'
import PhysicsPage from './pages/PhysicsPage'
import ExplorePage from './pages/ExplorePage'

function App() {
  const location = useLocation()

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 50,
      scale: 0.95
    },
    in: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    out: {
      opacity: 0,
      y: -50,
      scale: 0.95
    }
  }

  const pageTransition = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.6
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={{ height: '100%' }}
            >
              <SimulationPage />
            </motion.div>
          </AnimatePresence>
        } />
        <Route path="about" element={
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              style={{ height: '100%' }}
            >
              <AboutPage />
            </motion.div>
          </AnimatePresence>
        } />
            <Route path="physics" element={
              <AnimatePresence mode="wait">
                <motion.div
                  key={location.pathname}
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  style={{ height: '100%' }}
                >
                  <PhysicsPage />
                </motion.div>
              </AnimatePresence>
            } />
            <Route path="explore" element={
              <AnimatePresence mode="wait">
                <motion.div
                  key={location.pathname}
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={pageTransition}
                  style={{ height: '100%' }}
                >
                  <ExplorePage />
                </motion.div>
              </AnimatePresence>
            } />
          </Route>
    </Routes>
  )
}

export default App
